/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AddOrUpdateEmailRequest,
  CreateExternalApiUserRequest,
  CreateExternalApiUserResponse,
  CreateUser,
  CreateUserExternalLoginRequest,
  CreateUserResponse,
  CreateUserResult,
  DeleteUserExternalLoginParams,
  GetCreateUsersParams,
  GetPaginatedSimpleUsersWithPersonNameForAdminParams,
  GetPaginatedSimpleUsersWithPersonNameParams,
  GetPaginatedUserDataParams,
  GetSimpleUsersWithNamesParams,
  GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams,
  GetUserExternalLoginsParams,
  GetUserGroupsParams,
  GetUserIdsByTreeNodesParams,
  GetUserLicensesParams,
  GetUserParams,
  GetUsersWithoutExternalLoginParams,
  SimpleLicense,
  SimpleUser,
  SimpleUserPagination,
  SimpleUserWithPersonAndEmailInfo,
  UpdateApiKeyRequest,
  UpdateApiKeyResponse,
  UpdateGroupMembershipsRequest,
  UpdateUser,
  UpdateUserExternalLoginRequest,
  UserDto,
  UserDtoPagination,
  UserExternalLoginDto
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetCreateUsersUrl = (params?: GetCreateUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["personIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetCreateUsers?${stringifiedParams}` : `/api/User/GetCreateUsers`
}

export const getCreateUsers = async (params?: GetCreateUsersParams, options?: Parameters<typeof customInstance>[1]): Promise<CreateUser[]> => {

  return customInstance<CreateUser[]>(getGetCreateUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCreateUsersQueryKey = (params?: GetCreateUsersParams,) => {
    return [
    `/api/User/GetCreateUsers`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCreateUsersQueryOptions = <TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(params?: GetCreateUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreateUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreateUsers>>> = ({ signal }) => getCreateUsers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCreateUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getCreateUsers>>>
export type GetCreateUsersQueryError = ErrorType<unknown>


export function useGetCreateUsers<TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(
 params: undefined |  GetCreateUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreateUsers>>,
          TError,
          Awaited<ReturnType<typeof getCreateUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreateUsers<TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(
 params?: GetCreateUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreateUsers>>,
          TError,
          Awaited<ReturnType<typeof getCreateUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreateUsers<TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(
 params?: GetCreateUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCreateUsers<TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(
 params?: GetCreateUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCreateUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCreateUsersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(params?: GetCreateUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreateUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreateUsers>>> = ({ signal }) => getCreateUsers(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetCreateUsersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCreateUsers>>>
export type GetCreateUsersSuspenseQueryError = ErrorType<unknown>


export function useGetCreateUsersSuspense<TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(
 params: undefined |  GetCreateUsersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreateUsersSuspense<TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(
 params?: GetCreateUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCreateUsersSuspense<TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(
 params?: GetCreateUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCreateUsersSuspense<TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(
 params?: GetCreateUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCreateUsersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUserCreateUrl = () => {




  return `/api/User/Create`
}

export const userCreate = async (createUser?: CreateUser, options?: Parameters<typeof customInstance>[1]): Promise<CreateUserResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<CreateUserResponse>(getUserCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createUser)
  }
);}





export const getUserCreateMutationKey = () => ['userCreate'] as const;

export const getUserCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userCreate>>, TError,UserCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userCreate>>, TError,UserCreateMutationVariables, TContext> => {

const mutationKey = getUserCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userCreate>>, UserCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  userCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserCreateMutationResult = NonNullable<Awaited<ReturnType<typeof userCreate>>>
    export type UserCreateMutationBody = BodyType<CreateUser> | undefined
    export type UserCreateMutationError = ErrorType<unknown>
    export type UserCreateMutationVariables = {data?: BodyType<CreateUser>}

    export const useUserCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userCreate>>, TError,UserCreateMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userCreate>>,
        TError,
        UserCreateMutationVariables,
        TContext
      > => {
      return useMutation(getUserCreateMutationOptions(options), queryClient);
    }
    export const getCreateUsersUrl = () => {




  return `/api/User/CreateUsers`
}

export const createUsers = async (createUser?: CreateUser[], options?: Parameters<typeof customInstance>[1]): Promise<CreateUserResult[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<CreateUserResult[]>(getCreateUsersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createUser)
  }
);}





export const getCreateUsersMutationKey = () => ['createUsers'] as const;

export const getCreateUsersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUsers>>, TError,CreateUsersMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createUsers>>, TError,CreateUsersMutationVariables, TContext> => {

const mutationKey = getCreateUsersMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUsers>>, CreateUsersMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createUsers(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUsersMutationResult = NonNullable<Awaited<ReturnType<typeof createUsers>>>
    export type CreateUsersMutationBody = BodyType<CreateUser[]> | undefined
    export type CreateUsersMutationError = ErrorType<unknown>
    export type CreateUsersMutationVariables = {data?: BodyType<CreateUser[]>}

    export const useCreateUsers = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUsers>>, TError,CreateUsersMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUsers>>,
        TError,
        CreateUsersMutationVariables,
        TContext
      > => {
      return useMutation(getCreateUsersMutationOptions(options), queryClient);
    }
    export const getUpdateGroupMembershipsUrl = () => {




  return `/api/User/UpdateGroupMemberships`
}

export const updateGroupMemberships = async (updateGroupMembershipsRequest?: UpdateGroupMembershipsRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getUpdateGroupMembershipsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateGroupMembershipsRequest)
  }
);}





export const getUpdateGroupMembershipsMutationKey = () => ['updateGroupMemberships'] as const;

export const getUpdateGroupMembershipsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGroupMemberships>>, TError,UpdateGroupMembershipsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateGroupMemberships>>, TError,UpdateGroupMembershipsMutationVariables, TContext> => {

const mutationKey = getUpdateGroupMembershipsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGroupMemberships>>, UpdateGroupMembershipsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateGroupMemberships(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateGroupMembershipsMutationResult = NonNullable<Awaited<ReturnType<typeof updateGroupMemberships>>>
    export type UpdateGroupMembershipsMutationBody = BodyType<UpdateGroupMembershipsRequest> | undefined
    export type UpdateGroupMembershipsMutationError = ErrorType<unknown>
    export type UpdateGroupMembershipsMutationVariables = {data?: BodyType<UpdateGroupMembershipsRequest>}

    export const useUpdateGroupMemberships = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGroupMemberships>>, TError,UpdateGroupMembershipsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateGroupMemberships>>,
        TError,
        UpdateGroupMembershipsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateGroupMembershipsMutationOptions(options), queryClient);
    }
    export const getGetPaginatedUserDataUrl = (params: GetPaginatedUserDataParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["includeUserIds","excludeUserIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetPaginatedUserData?${stringifiedParams}` : `/api/User/GetPaginatedUserData`
}

export const getPaginatedUserData = async (params: GetPaginatedUserDataParams, options?: Parameters<typeof customInstance>[1]): Promise<UserDtoPagination> => {

  return customInstance<UserDtoPagination>(getGetPaginatedUserDataUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPaginatedUserDataQueryKey = (params?: GetPaginatedUserDataParams,) => {
    return [
    `/api/User/GetPaginatedUserData`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPaginatedUserDataQueryOptions = <TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(params: GetPaginatedUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaginatedUserDataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaginatedUserData>>> = ({ signal }) => getPaginatedUserData(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaginatedUserDataQueryResult = NonNullable<Awaited<ReturnType<typeof getPaginatedUserData>>>
export type GetPaginatedUserDataQueryError = ErrorType<unknown>


export function useGetPaginatedUserData<TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(
 params: GetPaginatedUserDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaginatedUserData>>,
          TError,
          Awaited<ReturnType<typeof getPaginatedUserData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaginatedUserData<TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(
 params: GetPaginatedUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaginatedUserData>>,
          TError,
          Awaited<ReturnType<typeof getPaginatedUserData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaginatedUserData<TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(
 params: GetPaginatedUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPaginatedUserData<TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(
 params: GetPaginatedUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaginatedUserDataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPaginatedUserDataSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(params: GetPaginatedUserDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaginatedUserDataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaginatedUserData>>> = ({ signal }) => getPaginatedUserData(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPaginatedUserDataSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPaginatedUserData>>>
export type GetPaginatedUserDataSuspenseQueryError = ErrorType<unknown>


export function useGetPaginatedUserDataSuspense<TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(
 params: GetPaginatedUserDataParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaginatedUserDataSuspense<TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(
 params: GetPaginatedUserDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaginatedUserDataSuspense<TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(
 params: GetPaginatedUserDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPaginatedUserDataSuspense<TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(
 params: GetPaginatedUserDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaginatedUserDataSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUserUrl = (params?: GetUserParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetUser?${stringifiedParams}` : `/api/User/GetUser`
}

export const getUser = async (params?: GetUserParams, options?: Parameters<typeof customInstance>[1]): Promise<UserDto> => {

  return customInstance<UserDto>(getGetUserUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserQueryKey = (params?: GetUserParams,) => {
    return [
    `/api/User/GetUser`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(params?: GetUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserQueryError = ErrorType<unknown>


export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUserParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(
 params?: GetUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(
 params?: GetUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(
 params?: GetUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUserSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(params?: GetUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserSuspenseQueryError = ErrorType<unknown>


export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUserParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(
 params?: GetUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(
 params?: GetUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(
 params?: GetUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSimpleUsersWithPersonAndEmailInfoForAbsenceUrl = (params: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["includeUserIds","excludeUserIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetSimpleUsersWithPersonAndEmailInfoForAbsence?${stringifiedParams}` : `/api/User/GetSimpleUsersWithPersonAndEmailInfoForAbsence`
}

export const getSimpleUsersWithPersonAndEmailInfoForAbsence = async (params: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options?: Parameters<typeof customInstance>[1]): Promise<SimpleUserWithPersonAndEmailInfo[]> => {

  return customInstance<SimpleUserWithPersonAndEmailInfo[]>(getGetSimpleUsersWithPersonAndEmailInfoForAbsenceUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSimpleUsersWithPersonAndEmailInfoForAbsenceQueryKey = (params?: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams,) => {
    return [
    `/api/User/GetSimpleUsersWithPersonAndEmailInfoForAbsence`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSimpleUsersWithPersonAndEmailInfoForAbsenceQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(params: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleUsersWithPersonAndEmailInfoForAbsenceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>> = ({ signal }) => getSimpleUsersWithPersonAndEmailInfoForAbsence(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSimpleUsersWithPersonAndEmailInfoForAbsenceQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>>
export type GetSimpleUsersWithPersonAndEmailInfoForAbsenceQueryError = ErrorType<unknown>


export function useGetSimpleUsersWithPersonAndEmailInfoForAbsence<TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(
 params: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>,
          TError,
          Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleUsersWithPersonAndEmailInfoForAbsence<TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(
 params: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>,
          TError,
          Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleUsersWithPersonAndEmailInfoForAbsence<TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(
 params: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimpleUsersWithPersonAndEmailInfoForAbsence<TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(
 params: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimpleUsersWithPersonAndEmailInfoForAbsenceQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSimpleUsersWithPersonAndEmailInfoForAbsenceSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(params: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleUsersWithPersonAndEmailInfoForAbsenceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>> = ({ signal }) => getSimpleUsersWithPersonAndEmailInfoForAbsence(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSimpleUsersWithPersonAndEmailInfoForAbsenceSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>>
export type GetSimpleUsersWithPersonAndEmailInfoForAbsenceSuspenseQueryError = ErrorType<unknown>


export function useGetSimpleUsersWithPersonAndEmailInfoForAbsenceSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(
 params: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleUsersWithPersonAndEmailInfoForAbsenceSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(
 params: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleUsersWithPersonAndEmailInfoForAbsenceSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(
 params: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimpleUsersWithPersonAndEmailInfoForAbsenceSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(
 params: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimpleUsersWithPersonAndEmailInfoForAbsenceSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPaginatedSimpleUsersWithPersonNameUrl = (params: GetPaginatedSimpleUsersWithPersonNameParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["excludeUserIds","includeUserIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetPaginatedSimpleUsersWithPersonName?${stringifiedParams}` : `/api/User/GetPaginatedSimpleUsersWithPersonName`
}

export const getPaginatedSimpleUsersWithPersonName = async (params: GetPaginatedSimpleUsersWithPersonNameParams, options?: Parameters<typeof customInstance>[1]): Promise<SimpleUserPagination> => {

  return customInstance<SimpleUserPagination>(getGetPaginatedSimpleUsersWithPersonNameUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPaginatedSimpleUsersWithPersonNameQueryKey = (params?: GetPaginatedSimpleUsersWithPersonNameParams,) => {
    return [
    `/api/User/GetPaginatedSimpleUsersWithPersonName`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPaginatedSimpleUsersWithPersonNameQueryOptions = <TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(params: GetPaginatedSimpleUsersWithPersonNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaginatedSimpleUsersWithPersonNameQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>> = ({ signal }) => getPaginatedSimpleUsersWithPersonName(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaginatedSimpleUsersWithPersonNameQueryResult = NonNullable<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>>
export type GetPaginatedSimpleUsersWithPersonNameQueryError = ErrorType<unknown>


export function useGetPaginatedSimpleUsersWithPersonName<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>,
          TError,
          Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaginatedSimpleUsersWithPersonName<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>,
          TError,
          Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaginatedSimpleUsersWithPersonName<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPaginatedSimpleUsersWithPersonName<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaginatedSimpleUsersWithPersonNameQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPaginatedSimpleUsersWithPersonNameSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(params: GetPaginatedSimpleUsersWithPersonNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaginatedSimpleUsersWithPersonNameQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>> = ({ signal }) => getPaginatedSimpleUsersWithPersonName(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPaginatedSimpleUsersWithPersonNameSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>>
export type GetPaginatedSimpleUsersWithPersonNameSuspenseQueryError = ErrorType<unknown>


export function useGetPaginatedSimpleUsersWithPersonNameSuspense<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaginatedSimpleUsersWithPersonNameSuspense<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaginatedSimpleUsersWithPersonNameSuspense<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPaginatedSimpleUsersWithPersonNameSuspense<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaginatedSimpleUsersWithPersonNameSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPaginatedSimpleUsersWithPersonNameForAdminUrl = (params: GetPaginatedSimpleUsersWithPersonNameForAdminParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["excludeUserIds","includeUserIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetPaginatedSimpleUsersWithPersonNameForAdmin?${stringifiedParams}` : `/api/User/GetPaginatedSimpleUsersWithPersonNameForAdmin`
}

export const getPaginatedSimpleUsersWithPersonNameForAdmin = async (params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options?: Parameters<typeof customInstance>[1]): Promise<SimpleUserPagination> => {

  return customInstance<SimpleUserPagination>(getGetPaginatedSimpleUsersWithPersonNameForAdminUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPaginatedSimpleUsersWithPersonNameForAdminQueryKey = (params?: GetPaginatedSimpleUsersWithPersonNameForAdminParams,) => {
    return [
    `/api/User/GetPaginatedSimpleUsersWithPersonNameForAdmin`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPaginatedSimpleUsersWithPersonNameForAdminQueryOptions = <TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaginatedSimpleUsersWithPersonNameForAdminQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>> = ({ signal }) => getPaginatedSimpleUsersWithPersonNameForAdmin(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaginatedSimpleUsersWithPersonNameForAdminQueryResult = NonNullable<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>>
export type GetPaginatedSimpleUsersWithPersonNameForAdminQueryError = ErrorType<unknown>


export function useGetPaginatedSimpleUsersWithPersonNameForAdmin<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>,
          TError,
          Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaginatedSimpleUsersWithPersonNameForAdmin<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>,
          TError,
          Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaginatedSimpleUsersWithPersonNameForAdmin<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPaginatedSimpleUsersWithPersonNameForAdmin<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaginatedSimpleUsersWithPersonNameForAdminQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPaginatedSimpleUsersWithPersonNameForAdminSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaginatedSimpleUsersWithPersonNameForAdminQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>> = ({ signal }) => getPaginatedSimpleUsersWithPersonNameForAdmin(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPaginatedSimpleUsersWithPersonNameForAdminSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>>
export type GetPaginatedSimpleUsersWithPersonNameForAdminSuspenseQueryError = ErrorType<unknown>


export function useGetPaginatedSimpleUsersWithPersonNameForAdminSuspense<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaginatedSimpleUsersWithPersonNameForAdminSuspense<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaginatedSimpleUsersWithPersonNameForAdminSuspense<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPaginatedSimpleUsersWithPersonNameForAdminSuspense<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaginatedSimpleUsersWithPersonNameForAdminSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSimpleUsersWithNamesUrl = (params?: GetSimpleUsersWithNamesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["userIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetSimpleUsersWithNames?${stringifiedParams}` : `/api/User/GetSimpleUsersWithNames`
}

export const getSimpleUsersWithNames = async (params?: GetSimpleUsersWithNamesParams, options?: Parameters<typeof customInstance>[1]): Promise<SimpleUser[]> => {

  return customInstance<SimpleUser[]>(getGetSimpleUsersWithNamesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSimpleUsersWithNamesQueryKey = (params?: GetSimpleUsersWithNamesParams,) => {
    return [
    `/api/User/GetSimpleUsersWithNames`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSimpleUsersWithNamesQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(params?: GetSimpleUsersWithNamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleUsersWithNamesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleUsersWithNames>>> = ({ signal }) => getSimpleUsersWithNames(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSimpleUsersWithNamesQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleUsersWithNames>>>
export type GetSimpleUsersWithNamesQueryError = ErrorType<unknown>


export function useGetSimpleUsersWithNames<TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimpleUsersWithNamesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleUsersWithNames>>,
          TError,
          Awaited<ReturnType<typeof getSimpleUsersWithNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleUsersWithNames<TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersWithNamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleUsersWithNames>>,
          TError,
          Awaited<ReturnType<typeof getSimpleUsersWithNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleUsersWithNames<TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersWithNamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimpleUsersWithNames<TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersWithNamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimpleUsersWithNamesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSimpleUsersWithNamesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(params?: GetSimpleUsersWithNamesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleUsersWithNamesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleUsersWithNames>>> = ({ signal }) => getSimpleUsersWithNames(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSimpleUsersWithNamesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleUsersWithNames>>>
export type GetSimpleUsersWithNamesSuspenseQueryError = ErrorType<unknown>


export function useGetSimpleUsersWithNamesSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimpleUsersWithNamesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleUsersWithNamesSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersWithNamesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleUsersWithNamesSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersWithNamesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimpleUsersWithNamesSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersWithNamesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimpleUsersWithNamesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateUserUrl = () => {




  return `/api/User/UpdateUser`
}

export const updateUser = async (updateUserBody?: UpdateUser, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getUpdateUserUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateUserBody)
  }
);}





export const getUpdateUserMutationKey = () => ['updateUser'] as const;

export const getUpdateUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,UpdateUserMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,UpdateUserMutationVariables, TContext> => {

const mutationKey = getUpdateUserMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, UpdateUserMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
    export type UpdateUserMutationBody = BodyType<UpdateUser> | undefined
    export type UpdateUserMutationError = ErrorType<unknown>
    export type UpdateUserMutationVariables = {data?: BodyType<UpdateUser>}

    export const useUpdateUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,UpdateUserMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUser>>,
        TError,
        UpdateUserMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateUserMutationOptions(options), queryClient);
    }
    export const getGetUserGroupsUrl = (params?: GetUserGroupsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetUserGroups?${stringifiedParams}` : `/api/User/GetUserGroups`
}

export const getUserGroups = async (params?: GetUserGroupsParams, options?: Parameters<typeof customInstance>[1]): Promise<SimpleUser[]> => {

  return customInstance<SimpleUser[]>(getGetUserGroupsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserGroupsQueryKey = (params?: GetUserGroupsParams,) => {
    return [
    `/api/User/GetUserGroups`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(params?: GetUserGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGroupsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGroups>>> = ({ signal }) => getUserGroups(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGroups>>>
export type GetUserGroupsQueryError = ErrorType<unknown>


export function useGetUserGroups<TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUserGroupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserGroups>>,
          TError,
          Awaited<ReturnType<typeof getUserGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserGroups<TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(
 params?: GetUserGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserGroups>>,
          TError,
          Awaited<ReturnType<typeof getUserGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserGroups<TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(
 params?: GetUserGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserGroups<TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(
 params?: GetUserGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUserGroupsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(params?: GetUserGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGroupsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGroups>>> = ({ signal }) => getUserGroups(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetUserGroupsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGroups>>>
export type GetUserGroupsSuspenseQueryError = ErrorType<unknown>


export function useGetUserGroupsSuspense<TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUserGroupsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserGroupsSuspense<TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(
 params?: GetUserGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserGroupsSuspense<TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(
 params?: GetUserGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserGroupsSuspense<TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(
 params?: GetUserGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserGroupsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyLicensesUrl = () => {




  return `/api/User/GetMyLicenses`
}

export const getMyLicenses = async ( options?: Parameters<typeof customInstance>[1]): Promise<SimpleLicense[]> => {

  return customInstance<SimpleLicense[]>(getGetMyLicensesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyLicensesQueryKey = () => {
    return [
    `/api/User/GetMyLicenses`
    ] as const;
    }


export const getGetMyLicensesQueryOptions = <TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyLicensesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyLicenses>>> = ({ signal }) => getMyLicenses({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyLicensesQueryResult = NonNullable<Awaited<ReturnType<typeof getMyLicenses>>>
export type GetMyLicensesQueryError = ErrorType<unknown>


export function useGetMyLicenses<TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyLicenses>>,
          TError,
          Awaited<ReturnType<typeof getMyLicenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyLicenses<TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyLicenses>>,
          TError,
          Awaited<ReturnType<typeof getMyLicenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyLicenses<TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyLicenses<TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyLicensesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyLicensesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyLicensesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyLicenses>>> = ({ signal }) => getMyLicenses({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetMyLicensesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyLicenses>>>
export type GetMyLicensesSuspenseQueryError = ErrorType<unknown>


export function useGetMyLicensesSuspense<TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyLicensesSuspense<TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyLicensesSuspense<TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyLicensesSuspense<TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyLicensesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUserLicensesUrl = (params?: GetUserLicensesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetUserLicenses?${stringifiedParams}` : `/api/User/GetUserLicenses`
}

export const getUserLicenses = async (params?: GetUserLicensesParams, options?: Parameters<typeof customInstance>[1]): Promise<SimpleLicense[]> => {

  return customInstance<SimpleLicense[]>(getGetUserLicensesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserLicensesQueryKey = (params?: GetUserLicensesParams,) => {
    return [
    `/api/User/GetUserLicenses`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserLicensesQueryOptions = <TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(params?: GetUserLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserLicensesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserLicenses>>> = ({ signal }) => getUserLicenses(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserLicensesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserLicenses>>>
export type GetUserLicensesQueryError = ErrorType<unknown>


export function useGetUserLicenses<TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUserLicensesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserLicenses>>,
          TError,
          Awaited<ReturnType<typeof getUserLicenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserLicenses<TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(
 params?: GetUserLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserLicenses>>,
          TError,
          Awaited<ReturnType<typeof getUserLicenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserLicenses<TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(
 params?: GetUserLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserLicenses<TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(
 params?: GetUserLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserLicensesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUserLicensesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(params?: GetUserLicensesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserLicensesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserLicenses>>> = ({ signal }) => getUserLicenses(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetUserLicensesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUserLicenses>>>
export type GetUserLicensesSuspenseQueryError = ErrorType<unknown>


export function useGetUserLicensesSuspense<TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUserLicensesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserLicensesSuspense<TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(
 params?: GetUserLicensesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserLicensesSuspense<TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(
 params?: GetUserLicensesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserLicensesSuspense<TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(
 params?: GetUserLicensesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserLicensesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAuthenticatedUserUrl = () => {




  return `/api/User/GetAuthenticatedUser`
}

export const getAuthenticatedUser = async ( options?: Parameters<typeof customInstance>[1]): Promise<UserDto> => {

  return customInstance<UserDto>(getGetAuthenticatedUserUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAuthenticatedUserQueryKey = () => {
    return [
    `/api/User/GetAuthenticatedUser`
    ] as const;
    }


export const getGetAuthenticatedUserQueryOptions = <TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthenticatedUserQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthenticatedUser>>> = ({ signal }) => getAuthenticatedUser({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuthenticatedUserQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthenticatedUser>>>
export type GetAuthenticatedUserQueryError = ErrorType<unknown>


export function useGetAuthenticatedUser<TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthenticatedUser>>,
          TError,
          Awaited<ReturnType<typeof getAuthenticatedUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthenticatedUser<TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthenticatedUser>>,
          TError,
          Awaited<ReturnType<typeof getAuthenticatedUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthenticatedUser<TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAuthenticatedUser<TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuthenticatedUserQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAuthenticatedUserSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthenticatedUserQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthenticatedUser>>> = ({ signal }) => getAuthenticatedUser({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAuthenticatedUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthenticatedUser>>>
export type GetAuthenticatedUserSuspenseQueryError = ErrorType<unknown>


export function useGetAuthenticatedUserSuspense<TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthenticatedUserSuspense<TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthenticatedUserSuspense<TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAuthenticatedUserSuspense<TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuthenticatedUserSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateExternalServiceUserUrl = () => {




  return `/api/User/CreateExternalServiceUser`
}

export const createExternalServiceUser = async (createExternalApiUserRequest?: CreateExternalApiUserRequest, options?: Parameters<typeof customInstance>[1]): Promise<CreateExternalApiUserResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<CreateExternalApiUserResponse>(getCreateExternalServiceUserUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createExternalApiUserRequest)
  }
);}





export const getCreateExternalServiceUserMutationKey = () => ['createExternalServiceUser'] as const;

export const getCreateExternalServiceUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExternalServiceUser>>, TError,CreateExternalServiceUserMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createExternalServiceUser>>, TError,CreateExternalServiceUserMutationVariables, TContext> => {

const mutationKey = getCreateExternalServiceUserMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createExternalServiceUser>>, CreateExternalServiceUserMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createExternalServiceUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateExternalServiceUserMutationResult = NonNullable<Awaited<ReturnType<typeof createExternalServiceUser>>>
    export type CreateExternalServiceUserMutationBody = BodyType<CreateExternalApiUserRequest> | undefined
    export type CreateExternalServiceUserMutationError = ErrorType<unknown>
    export type CreateExternalServiceUserMutationVariables = {data?: BodyType<CreateExternalApiUserRequest>}

    export const useCreateExternalServiceUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExternalServiceUser>>, TError,CreateExternalServiceUserMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createExternalServiceUser>>,
        TError,
        CreateExternalServiceUserMutationVariables,
        TContext
      > => {
      return useMutation(getCreateExternalServiceUserMutationOptions(options), queryClient);
    }
    export const getGetDatabaseRulesUrl = () => {




  return `/api/User/GetDatabaseRules`
}

export const getDatabaseRules = async ( options?: Parameters<typeof customInstance>[1]): Promise<string[]> => {

  return customInstance<string[]>(getGetDatabaseRulesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDatabaseRulesQueryKey = () => {
    return [
    `/api/User/GetDatabaseRules`
    ] as const;
    }


export const getGetDatabaseRulesQueryOptions = <TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatabaseRulesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatabaseRules>>> = ({ signal }) => getDatabaseRules({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDatabaseRulesQueryResult = NonNullable<Awaited<ReturnType<typeof getDatabaseRules>>>
export type GetDatabaseRulesQueryError = ErrorType<unknown>


export function useGetDatabaseRules<TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatabaseRules>>,
          TError,
          Awaited<ReturnType<typeof getDatabaseRules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatabaseRules<TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatabaseRules>>,
          TError,
          Awaited<ReturnType<typeof getDatabaseRules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatabaseRules<TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDatabaseRules<TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDatabaseRulesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetDatabaseRulesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatabaseRulesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatabaseRules>>> = ({ signal }) => getDatabaseRules({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetDatabaseRulesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDatabaseRules>>>
export type GetDatabaseRulesSuspenseQueryError = ErrorType<unknown>


export function useGetDatabaseRulesSuspense<TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatabaseRulesSuspense<TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatabaseRulesSuspense<TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDatabaseRulesSuspense<TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDatabaseRulesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateApiKeyUrl = () => {




  return `/api/User/UpdateApiKey`
}

export const updateApiKey = async (updateApiKeyRequest?: UpdateApiKeyRequest, options?: Parameters<typeof customInstance>[1]): Promise<UpdateApiKeyResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<UpdateApiKeyResponse>(getUpdateApiKeyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateApiKeyRequest)
  }
);}





export const getUpdateApiKeyMutationKey = () => ['updateApiKey'] as const;

export const getUpdateApiKeyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateApiKey>>, TError,UpdateApiKeyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateApiKey>>, TError,UpdateApiKeyMutationVariables, TContext> => {

const mutationKey = getUpdateApiKeyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateApiKey>>, UpdateApiKeyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateApiKey(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof updateApiKey>>>
    export type UpdateApiKeyMutationBody = BodyType<UpdateApiKeyRequest> | undefined
    export type UpdateApiKeyMutationError = ErrorType<unknown>
    export type UpdateApiKeyMutationVariables = {data?: BodyType<UpdateApiKeyRequest>}

    export const useUpdateApiKey = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateApiKey>>, TError,UpdateApiKeyMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateApiKey>>,
        TError,
        UpdateApiKeyMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateApiKeyMutationOptions(options), queryClient);
    }
    export const getGetUserExternalLoginsUrl = (params?: GetUserExternalLoginsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetUserExternalLogins?${stringifiedParams}` : `/api/User/GetUserExternalLogins`
}

export const getUserExternalLogins = async (params?: GetUserExternalLoginsParams, options?: Parameters<typeof customInstance>[1]): Promise<UserExternalLoginDto[]> => {

  return customInstance<UserExternalLoginDto[]>(getGetUserExternalLoginsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserExternalLoginsQueryKey = (params?: GetUserExternalLoginsParams,) => {
    return [
    `/api/User/GetUserExternalLogins`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserExternalLoginsQueryOptions = <TData = Awaited<ReturnType<typeof getUserExternalLogins>>, TError = ErrorType<unknown>>(params?: GetUserExternalLoginsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExternalLogins>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserExternalLoginsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserExternalLogins>>> = ({ signal }) => getUserExternalLogins(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserExternalLogins>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserExternalLoginsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserExternalLogins>>>
export type GetUserExternalLoginsQueryError = ErrorType<unknown>


export function useGetUserExternalLogins<TData = Awaited<ReturnType<typeof getUserExternalLogins>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUserExternalLoginsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExternalLogins>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserExternalLogins>>,
          TError,
          Awaited<ReturnType<typeof getUserExternalLogins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserExternalLogins<TData = Awaited<ReturnType<typeof getUserExternalLogins>>, TError = ErrorType<unknown>>(
 params?: GetUserExternalLoginsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExternalLogins>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserExternalLogins>>,
          TError,
          Awaited<ReturnType<typeof getUserExternalLogins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserExternalLogins<TData = Awaited<ReturnType<typeof getUserExternalLogins>>, TError = ErrorType<unknown>>(
 params?: GetUserExternalLoginsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExternalLogins>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserExternalLogins<TData = Awaited<ReturnType<typeof getUserExternalLogins>>, TError = ErrorType<unknown>>(
 params?: GetUserExternalLoginsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserExternalLogins>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserExternalLoginsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUserExternalLoginsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUserExternalLogins>>, TError = ErrorType<unknown>>(params?: GetUserExternalLoginsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserExternalLogins>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserExternalLoginsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserExternalLogins>>> = ({ signal }) => getUserExternalLogins(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserExternalLogins>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetUserExternalLoginsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUserExternalLogins>>>
export type GetUserExternalLoginsSuspenseQueryError = ErrorType<unknown>


export function useGetUserExternalLoginsSuspense<TData = Awaited<ReturnType<typeof getUserExternalLogins>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUserExternalLoginsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserExternalLogins>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserExternalLoginsSuspense<TData = Awaited<ReturnType<typeof getUserExternalLogins>>, TError = ErrorType<unknown>>(
 params?: GetUserExternalLoginsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserExternalLogins>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserExternalLoginsSuspense<TData = Awaited<ReturnType<typeof getUserExternalLogins>>, TError = ErrorType<unknown>>(
 params?: GetUserExternalLoginsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserExternalLogins>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserExternalLoginsSuspense<TData = Awaited<ReturnType<typeof getUserExternalLogins>>, TError = ErrorType<unknown>>(
 params?: GetUserExternalLoginsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserExternalLogins>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserExternalLoginsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUsersWithoutExternalLoginUrl = (params?: GetUsersWithoutExternalLoginParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetUsersWithoutExternalLogin?${stringifiedParams}` : `/api/User/GetUsersWithoutExternalLogin`
}

export const getUsersWithoutExternalLogin = async (params?: GetUsersWithoutExternalLoginParams, options?: Parameters<typeof customInstance>[1]): Promise<UserDto[]> => {

  return customInstance<UserDto[]>(getGetUsersWithoutExternalLoginUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUsersWithoutExternalLoginQueryKey = (params?: GetUsersWithoutExternalLoginParams,) => {
    return [
    `/api/User/GetUsersWithoutExternalLogin`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUsersWithoutExternalLoginQueryOptions = <TData = Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError = ErrorType<unknown>>(params?: GetUsersWithoutExternalLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersWithoutExternalLoginQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>> = ({ signal }) => getUsersWithoutExternalLogin(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersWithoutExternalLoginQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>>
export type GetUsersWithoutExternalLoginQueryError = ErrorType<unknown>


export function useGetUsersWithoutExternalLogin<TData = Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUsersWithoutExternalLoginParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>,
          TError,
          Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersWithoutExternalLogin<TData = Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError = ErrorType<unknown>>(
 params?: GetUsersWithoutExternalLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>,
          TError,
          Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersWithoutExternalLogin<TData = Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError = ErrorType<unknown>>(
 params?: GetUsersWithoutExternalLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUsersWithoutExternalLogin<TData = Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError = ErrorType<unknown>>(
 params?: GetUsersWithoutExternalLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersWithoutExternalLoginQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUsersWithoutExternalLoginSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError = ErrorType<unknown>>(params?: GetUsersWithoutExternalLoginParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersWithoutExternalLoginQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>> = ({ signal }) => getUsersWithoutExternalLogin(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetUsersWithoutExternalLoginSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>>
export type GetUsersWithoutExternalLoginSuspenseQueryError = ErrorType<unknown>


export function useGetUsersWithoutExternalLoginSuspense<TData = Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUsersWithoutExternalLoginParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersWithoutExternalLoginSuspense<TData = Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError = ErrorType<unknown>>(
 params?: GetUsersWithoutExternalLoginParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersWithoutExternalLoginSuspense<TData = Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError = ErrorType<unknown>>(
 params?: GetUsersWithoutExternalLoginParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUsersWithoutExternalLoginSuspense<TData = Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError = ErrorType<unknown>>(
 params?: GetUsersWithoutExternalLoginParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUsersWithoutExternalLogin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersWithoutExternalLoginSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateUserExternalLoginsUrl = () => {




  return `/api/User/CreateUserExternalLogins`
}

export const createUserExternalLogins = async (createUserExternalLoginRequest?: CreateUserExternalLoginRequest[], options?: Parameters<typeof customInstance>[1]): Promise<UserExternalLoginDto[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<UserExternalLoginDto[]>(getCreateUserExternalLoginsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createUserExternalLoginRequest)
  }
);}





export const getCreateUserExternalLoginsMutationKey = () => ['createUserExternalLogins'] as const;

export const getCreateUserExternalLoginsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserExternalLogins>>, TError,CreateUserExternalLoginsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createUserExternalLogins>>, TError,CreateUserExternalLoginsMutationVariables, TContext> => {

const mutationKey = getCreateUserExternalLoginsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserExternalLogins>>, CreateUserExternalLoginsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createUserExternalLogins(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserExternalLoginsMutationResult = NonNullable<Awaited<ReturnType<typeof createUserExternalLogins>>>
    export type CreateUserExternalLoginsMutationBody = BodyType<CreateUserExternalLoginRequest[]> | undefined
    export type CreateUserExternalLoginsMutationError = ErrorType<unknown>
    export type CreateUserExternalLoginsMutationVariables = {data?: BodyType<CreateUserExternalLoginRequest[]>}

    export const useCreateUserExternalLogins = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserExternalLogins>>, TError,CreateUserExternalLoginsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUserExternalLogins>>,
        TError,
        CreateUserExternalLoginsMutationVariables,
        TContext
      > => {
      return useMutation(getCreateUserExternalLoginsMutationOptions(options), queryClient);
    }
    export const getUpdateUserExternalLoginUrl = () => {




  return `/api/User/UpdateUserExternalLogin`
}

export const updateUserExternalLogin = async (updateUserExternalLoginRequest?: UpdateUserExternalLoginRequest, options?: Parameters<typeof customInstance>[1]): Promise<UserExternalLoginDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<UserExternalLoginDto>(getUpdateUserExternalLoginUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateUserExternalLoginRequest)
  }
);}





export const getUpdateUserExternalLoginMutationKey = () => ['updateUserExternalLogin'] as const;

export const getUpdateUserExternalLoginMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserExternalLogin>>, TError,UpdateUserExternalLoginMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserExternalLogin>>, TError,UpdateUserExternalLoginMutationVariables, TContext> => {

const mutationKey = getUpdateUserExternalLoginMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserExternalLogin>>, UpdateUserExternalLoginMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateUserExternalLogin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserExternalLoginMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserExternalLogin>>>
    export type UpdateUserExternalLoginMutationBody = BodyType<UpdateUserExternalLoginRequest> | undefined
    export type UpdateUserExternalLoginMutationError = ErrorType<unknown>
    export type UpdateUserExternalLoginMutationVariables = {data?: BodyType<UpdateUserExternalLoginRequest>}

    export const useUpdateUserExternalLogin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserExternalLogin>>, TError,UpdateUserExternalLoginMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUserExternalLogin>>,
        TError,
        UpdateUserExternalLoginMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateUserExternalLoginMutationOptions(options), queryClient);
    }
    export const getDeleteUserExternalLoginUrl = (params?: DeleteUserExternalLoginParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/DeleteUserExternalLogin?${stringifiedParams}` : `/api/User/DeleteUserExternalLogin`
}

export const deleteUserExternalLogin = async (params?: DeleteUserExternalLoginParams, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDeleteUserExternalLoginUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteUserExternalLoginMutationKey = () => ['deleteUserExternalLogin'] as const;

export const getDeleteUserExternalLoginMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserExternalLogin>>, TError,DeleteUserExternalLoginMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserExternalLogin>>, TError,DeleteUserExternalLoginMutationVariables, TContext> => {

const mutationKey = getDeleteUserExternalLoginMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserExternalLogin>>, DeleteUserExternalLoginMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  deleteUserExternalLogin(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserExternalLoginMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserExternalLogin>>>

    export type DeleteUserExternalLoginMutationError = ErrorType<unknown>
    export type DeleteUserExternalLoginMutationVariables = {params?: DeleteUserExternalLoginParams}

    export const useDeleteUserExternalLogin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserExternalLogin>>, TError,DeleteUserExternalLoginMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserExternalLogin>>,
        TError,
        DeleteUserExternalLoginMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteUserExternalLoginMutationOptions(options), queryClient);
    }
    export const getAddOrUpdateEmailUrl = () => {




  return `/api/User/AddOrUpdateEmail`
}

export const addOrUpdateEmail = async (addOrUpdateEmailRequest?: AddOrUpdateEmailRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getAddOrUpdateEmailUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addOrUpdateEmailRequest)
  }
);}





export const getAddOrUpdateEmailMutationKey = () => ['addOrUpdateEmail'] as const;

export const getAddOrUpdateEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOrUpdateEmail>>, TError,AddOrUpdateEmailMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addOrUpdateEmail>>, TError,AddOrUpdateEmailMutationVariables, TContext> => {

const mutationKey = getAddOrUpdateEmailMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addOrUpdateEmail>>, AddOrUpdateEmailMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  addOrUpdateEmail(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddOrUpdateEmailMutationResult = NonNullable<Awaited<ReturnType<typeof addOrUpdateEmail>>>
    export type AddOrUpdateEmailMutationBody = BodyType<AddOrUpdateEmailRequest> | undefined
    export type AddOrUpdateEmailMutationError = ErrorType<unknown>
    export type AddOrUpdateEmailMutationVariables = {data?: BodyType<AddOrUpdateEmailRequest>}

    export const useAddOrUpdateEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOrUpdateEmail>>, TError,AddOrUpdateEmailMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addOrUpdateEmail>>,
        TError,
        AddOrUpdateEmailMutationVariables,
        TContext
      > => {
      return useMutation(getAddOrUpdateEmailMutationOptions(options), queryClient);
    }
    export const getGetUserIdsByTreeNodesUrl = (params?: GetUserIdsByTreeNodesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["workAreaNodeNames","contractTypeNodeNames","productionNodeNames"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetUserIdsByTreeNodes?${stringifiedParams}` : `/api/User/GetUserIdsByTreeNodes`
}

export const getUserIdsByTreeNodes = async (params?: GetUserIdsByTreeNodesParams, options?: Parameters<typeof customInstance>[1]): Promise<number[]> => {

  return customInstance<number[]>(getGetUserIdsByTreeNodesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserIdsByTreeNodesQueryKey = (params?: GetUserIdsByTreeNodesParams,) => {
    return [
    `/api/User/GetUserIdsByTreeNodes`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserIdsByTreeNodesQueryOptions = <TData = Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError = ErrorType<unknown>>(params?: GetUserIdsByTreeNodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserIdsByTreeNodesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserIdsByTreeNodes>>> = ({ signal }) => getUserIdsByTreeNodes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserIdsByTreeNodesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserIdsByTreeNodes>>>
export type GetUserIdsByTreeNodesQueryError = ErrorType<unknown>


export function useGetUserIdsByTreeNodes<TData = Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUserIdsByTreeNodesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIdsByTreeNodes>>,
          TError,
          Awaited<ReturnType<typeof getUserIdsByTreeNodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIdsByTreeNodes<TData = Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError = ErrorType<unknown>>(
 params?: GetUserIdsByTreeNodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIdsByTreeNodes>>,
          TError,
          Awaited<ReturnType<typeof getUserIdsByTreeNodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIdsByTreeNodes<TData = Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError = ErrorType<unknown>>(
 params?: GetUserIdsByTreeNodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserIdsByTreeNodes<TData = Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError = ErrorType<unknown>>(
 params?: GetUserIdsByTreeNodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserIdsByTreeNodesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUserIdsByTreeNodesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError = ErrorType<unknown>>(params?: GetUserIdsByTreeNodesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserIdsByTreeNodesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserIdsByTreeNodes>>> = ({ signal }) => getUserIdsByTreeNodes(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetUserIdsByTreeNodesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUserIdsByTreeNodes>>>
export type GetUserIdsByTreeNodesSuspenseQueryError = ErrorType<unknown>


export function useGetUserIdsByTreeNodesSuspense<TData = Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUserIdsByTreeNodesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIdsByTreeNodesSuspense<TData = Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError = ErrorType<unknown>>(
 params?: GetUserIdsByTreeNodesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIdsByTreeNodesSuspense<TData = Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError = ErrorType<unknown>>(
 params?: GetUserIdsByTreeNodesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserIdsByTreeNodesSuspense<TData = Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError = ErrorType<unknown>>(
 params?: GetUserIdsByTreeNodesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserIdsByTreeNodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserIdsByTreeNodesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






